module.exports = __webpack_public_path__ + "img/arrow-left-end.513778b0.svg";